<template>
  <span>
    <b-button @click="show">Test in Unbrewed</b-button>
    <b-modal
      v-model="showModal"
      ok-only
      size="xl"
      title="Test in Unbrewed"
      ok-title="Done"
    >
      <p>
        <a href="https://unbrewed.xyz" target="_blank">
          Unbrewed
        </a>
        is an unofficial deck simulator for Unmatched.
      </p>
      <hr />
      <h5>Offline</h5>
      <p>
        Explore the synergies by drawing a hand, discarding, seeking cards from
        your deck, and more.
        <b-button
          :href="`https://unbrewed.xyz/offline/${versionId}`"
          target="_blank"
        >
          Test offline
        </b-button>
      </p>
      <hr />
      <h5>Online</h5>
      <p>
        Create/join the same lobby as a friend and see each other’s stats and
        actions in real time.
        <b-row>
          <b-col cols="12" sm="6">
            <b-form-group
              label="Lobby name"
              description="Enter a name for your lobby."
            >
              <b-form-input
                v-model.trim="lobbyName"
                placeholder="default"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6">
            <b-form-group
              label="Player name"
              description="Enter your player name."
            >
              <b-form-input
                v-model.trim="playerName"
                :placeholder="defaultPlayer"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          :href="
            `https://unbrewed.xyz/online/${lobby}/${player}?deck=${versionId}`
          "
          target="_blank"
        >
          Play online
        </b-button>
      </p>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "PlayInUnbrewed",
  props: ["versionId"],
  data() {
    return {
      showModal: false,
      lobbyName: "",
      playerName: ""
    };
  },
  computed: {
    lobby() {
      return this.lobbyName || "default";
    },
    player() {
      return this.playerName || this.defaultPlayer;
    },
    defaultPlayer() {
      return this.$store.getters.currentUser || "default";
    }
  },
  methods: {
    show() {
      this.showModal = true;
    }
  }
};
</script>
